// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-calendar-daily {
  background-color: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
  border-left: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
  border-top: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily__intervals-head {
  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily__intervals-head::after {
  background: rgba(var(--v-border-color), var(--v-border-opacity));
  background: linear-gradient(90deg, transparent, rgba(var(--v-border-color), var(--v-border-opacity)));
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily_head-day {
  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
  border-bottom: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-weekday,
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-day-label {
  color: rgb(var(--v-theme-on-surface));
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily__intervals-body {
  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily__intervals-body .v-calendar-daily__interval-text {
  color: rgb(var(--v-theme-on-surface));
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily__day {
  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
  border-bottom: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily__day-interval {
  border-top: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily__day-interval:first-child {
  border-top: none !important;
}
:where(.vuetify-styles) .v-calendar-daily .v-calendar-daily__interval::after {
  border-top: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}

:where(.vuetify-styles) .v-calendar-daily {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}

:where(.vuetify-styles) .v-calendar-daily__head {
  flex: none;
  display: flex;
}

:where(.vuetify-styles) .v-calendar-daily__intervals-head {
  flex: none;
  position: relative;
}
:where(.vuetify-styles) .v-calendar-daily__intervals-head::after {
  position: absolute;
  bottom: 0px;
  height: 1px;
  left: 0;
  right: 0;
  content: "";
}

:where(.vuetify-styles) .v-calendar-daily_head-day {
  flex: 1 1 auto;
  width: 0;
  position: relative;
}

:where(.vuetify-styles) .v-calendar-daily_head-weekday {
  -webkit-user-select: none;
          user-select: none;
  padding: 3px 0px 0px 0px;
  font-size: 11px;
  text-align: center;
  text-transform: uppercase;
}

:where(.vuetify-styles) .v-calendar-daily_head-day-label {
  -webkit-user-select: none;
          user-select: none;
  padding: 0px 0px 3px 0px;
  cursor: pointer;
  text-align: center;
}

:where(.vuetify-styles) .v-calendar-daily__body {
  flex: 1 1 60%;
  overflow: hidden;
  display: flex;
  position: relative;
  flex-direction: column;
}

:where(.vuetify-styles) .v-calendar-daily__scroll-area {
  overflow-y: scroll;
  flex: 1 1 auto;
  display: flex;
  align-items: flex-start;
}

:where(.vuetify-styles) .v-calendar-daily__pane {
  width: 100%;
  overflow-y: hidden;
  flex: none;
  display: flex;
  align-items: flex-start;
}

:where(.vuetify-styles) .v-calendar-daily__day-container {
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
}

:where(.vuetify-styles) .v-calendar-daily__intervals-body {
  flex: none;
  -webkit-user-select: none;
          user-select: none;
}

:where(.vuetify-styles) .v-calendar-daily__interval {
  text-align: right;
  padding-right: 8px;
  border-bottom: none;
  position: relative;
}
:where(.vuetify-styles) .v-calendar-daily__interval::after {
  width: 8px;
  position: absolute;
  height: 1px;
  display: block;
  content: "";
  right: 0;
  bottom: -1px;
}

:where(.vuetify-styles) .v-calendar-daily__interval-text {
  display: block;
  position: relative;
  top: -6px;
  font-size: 10px;
  padding-right: 4px;
}

:where(.vuetify-styles) .v-calendar-daily__day {
  flex: 1;
  width: 0;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VCalendar/VCalendarDaily.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,2EAA2E;EAC3E,0EAA0E;AAC5E;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,gEAAgE;EAChE,qGAAqG;AACvG;AACA;EACE,4EAA4E;EAC5E,6EAA6E;AAC/E;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,qCAAqC;AACvC;AACA;EACE,4EAA4E;EAC5E,6EAA6E;AAC/E;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,kBAAkB;AACpB","sourcesContent":[".v-calendar-daily {\n  background-color: rgb(var(--v-theme-surface));\n  color: rgb(var(--v-theme-on-surface));\n  border-left: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n  border-top: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-daily .v-calendar-daily__intervals-head {\n  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-daily .v-calendar-daily__intervals-head::after {\n  background: rgba(var(--v-border-color), var(--v-border-opacity));\n  background: linear-gradient(90deg, transparent, rgba(var(--v-border-color), var(--v-border-opacity)));\n}\n.v-calendar-daily .v-calendar-daily_head-day {\n  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n  border-bottom: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-weekday,\n.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-day-label {\n  color: rgb(var(--v-theme-on-surface));\n}\n.v-calendar-daily .v-calendar-daily__intervals-body {\n  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-daily .v-calendar-daily__intervals-body .v-calendar-daily__interval-text {\n  color: rgb(var(--v-theme-on-surface));\n}\n.v-calendar-daily .v-calendar-daily__day {\n  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n  border-bottom: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-daily .v-calendar-daily__day-interval {\n  border-top: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-daily .v-calendar-daily__day-interval:first-child {\n  border-top: none !important;\n}\n.v-calendar-daily .v-calendar-daily__interval::after {\n  border-top: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n\n.v-calendar-daily {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n\n.v-calendar-daily__head {\n  flex: none;\n  display: flex;\n}\n\n.v-calendar-daily__intervals-head {\n  flex: none;\n  position: relative;\n}\n.v-calendar-daily__intervals-head::after {\n  position: absolute;\n  bottom: 0px;\n  height: 1px;\n  left: 0;\n  right: 0;\n  content: \"\";\n}\n\n.v-calendar-daily_head-day {\n  flex: 1 1 auto;\n  width: 0;\n  position: relative;\n}\n\n.v-calendar-daily_head-weekday {\n  user-select: none;\n  padding: 3px 0px 0px 0px;\n  font-size: 11px;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.v-calendar-daily_head-day-label {\n  user-select: none;\n  padding: 0px 0px 3px 0px;\n  cursor: pointer;\n  text-align: center;\n}\n\n.v-calendar-daily__body {\n  flex: 1 1 60%;\n  overflow: hidden;\n  display: flex;\n  position: relative;\n  flex-direction: column;\n}\n\n.v-calendar-daily__scroll-area {\n  overflow-y: scroll;\n  flex: 1 1 auto;\n  display: flex;\n  align-items: flex-start;\n}\n\n.v-calendar-daily__pane {\n  width: 100%;\n  overflow-y: hidden;\n  flex: none;\n  display: flex;\n  align-items: flex-start;\n}\n\n.v-calendar-daily__day-container {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n}\n\n.v-calendar-daily__intervals-body {\n  flex: none;\n  user-select: none;\n}\n\n.v-calendar-daily__interval {\n  text-align: right;\n  padding-right: 8px;\n  border-bottom: none;\n  position: relative;\n}\n.v-calendar-daily__interval::after {\n  width: 8px;\n  position: absolute;\n  height: 1px;\n  display: block;\n  content: \"\";\n  right: 0;\n  bottom: -1px;\n}\n\n.v-calendar-daily__interval-text {\n  display: block;\n  position: relative;\n  top: -6px;\n  font-size: 10px;\n  padding-right: 4px;\n}\n\n.v-calendar-daily__day {\n  flex: 1;\n  width: 0;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
